import CaseStudies from './CaseStudies';
import ChangingConditions from './ChangingConditions';
import CompanyNews from './CompanyNews';
import Contests from './Contests';
import Events from './Events';
import ImprovingConditions from './ImprovingConditions';
import NewOffers from './NewOffers';
import OfferPause from './OfferPause';
import OfferRestart from './OfferRestart';
import OfferStop from './OfferStop';
import Press from './Press';
import Promo from './Promo';
import PromoMaterials from './PromoMaterials';
import SystemUpdates from './SystemUpdates';
import TechnicalWorks from './TechnicalWorks';
import WorkingConditions from './WorkingConditions';

export {
  CaseStudies,
  ChangingConditions,
  CompanyNews,
  Contests,
  Events,
  ImprovingConditions,
  NewOffers,
  OfferPause,
  OfferRestart,
  OfferStop,
  Press,
  Promo,
  PromoMaterials,
  SystemUpdates,
  TechnicalWorks,
  WorkingConditions,
};

export const ICONS_BY_NEWS_TYPE_NAME = {
  'case_studies': CaseStudies,
  'company_news': CompanyNews,
  'campaign_news': CompanyNews,
  'express_campaign_news': CompanyNews,
  'contests': Contests,
  'events': Events,
  'offers.new': NewOffers,
  'offers.improving_conditions': ImprovingConditions,
  'offers.changing_conditions': ChangingConditions,
  'offers.conditions': WorkingConditions,
  'offers.pause': OfferPause,
  'offers.play': OfferRestart,
  'offers.promotional_materials': PromoMaterials,
  'offers.stop': OfferStop,
  'press': Press,
  'promo': Promo,
  'actions': Promo,
  'system_update': SystemUpdates,
  'technical_work': TechnicalWorks,
};
